import { render, staticRenderFns } from "./editProduct.vue?vue&type=template&id=3405a812&scoped=true"
import script from "./editProduct.vue?vue&type=script&lang=ts"
export * from "./editProduct.vue?vue&type=script&lang=ts"
import style0 from "./editProduct.vue?vue&type=style&index=0&id=3405a812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405a812",
  null
  
)

export default component.exports